
import Notification from './notification'
import NotificationSinister from './notificationSinister'
import NotificationSinisters from './notificationSinisters'
import CustomNotification from './customNotification'

export default {
  notification: Notification,
  notificationSinister: NotificationSinister,
  notificationSinisters: NotificationSinisters,
  customNotification: CustomNotification,
}



// WEBPACK FOOTER //
// ./src/transformers/notification/index.js